import * as React from 'react';

import {useAppSelector} from "../../app/hooks";
import {selectBackgroundAudio, selectStatus} from "../yoga/yogaSlice";
import ReactPlayer from 'react-player/lazy'
import styles from './BackgroupPlayer.module.css';


export function BackgroundPlayer() {
    const status = useAppSelector(selectStatus);
    const backgroundUrl = useAppSelector(selectBackgroundAudio);
    const finalBackgroundUrl = backgroundUrl.includes("?t=") ? backgroundUrl : backgroundUrl+"?t=1"
    const playing = status === 'workout'
    return (
        <div className={styles.player}>
            <ReactPlayer url={finalBackgroundUrl} playing={playing} loop/>
        </div>
    )
}